<template>
    <div id="concorsi">
        <div class="hero-background" data-aos="fade">
            <svg class="background" width="1920" height="995" viewBox="0 0 1920 995" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0V994.2L960 914.2L1920 994.2V0H0Z" fill="#FDC60D"/>
                <path d="M1920 994.2L960 894.2L0 994.2V0H1920V994.2Z" fill="#3A424F"/>
            </svg>

            <svg class="overlay" width="1920" height="1055" viewBox="0 0 1920 1055" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="mobilehide" d="M202.9 719.1L-63 984.9C-79 1000.9 -79 1026.9 -63 1043C-47 1059 -21 1059 -4.90002 1043L261 777.1C277 761.1 277 735.1 261 719C253 711 242.5 707 232 707C221.4 707.1 210.9 711.1 202.9 719.1Z" fill="url(#paint0_linear)"/>
                <path d="M1833.5 0.700195C1789 1.1002 1746.4 24.1002 1717.3 57.8002C1688.2 91.4002 1671.8 134.8 1665.5 178.8C1662.2 202.1 1661.5 226 1653.8 248.2C1639.7 288.9 1604.1 318.3 1566.6 339.4C1529.1 360.5 1488.2 375.5 1452.4 399.4C1416.6 423.2 1385.1 458.7 1380.2 501.4C1376.3 536.1 1390.6 570.7 1411.3 598.8C1431.9 626.6 1459.8 649.9 1492.6 660.9C1532.2 674.3 1575.4 669.2 1616.8 663.3C1655.1 657.9 1693.4 651.8 1730.7 641.2C1800.6 621.4 1865.7 585.2 1920.1 537.1V35.0002C1897.7 13.2002 1867.3 0.700195 1834.7 0.700195C1834.2 0.700195 1833.8 0.700195 1833.5 0.700195Z" fill="url(#paint1_linear)"/>
                <path class="mobilehide" d="M81.1 48.2002C60.4 52.8002 40.9 61.7002 22.1 71.4002C14.7 75.3002 7.3 79.3002 0 83.4002V513.2C27.1 518.8 57.4 511.2 74.7 489.8C91.6 469 93.6 439.7 90.4 413C87.2 386.3 79.6 360 80.2 333.2C81 297.4 98 262.9 124.2 238.8C154.4 211.1 194.5 201.6 216.2 163.5C228.6 141.7 231.1 114.6 223 90.8002C209.4 51.1002 178.1 39.7002 143.3 39.7002C122.8 39.8002 101.1 43.8002 81.1 48.2002Z" fill="url(#paint2_linear)"/>
                <path class="mobilehide" d="M1236.6 534.5C1233.9 536.2 1231.9 538.9 1230.6 541.8C1225.4 552.7 1228 566.7 1236.7 575C1239.8 577.9 1243.5 580.2 1246 583.6C1249.6 588.5 1250.1 594.9 1251.7 600.6C1253.4 607.1 1255.7 613.5 1259.4 619.2C1263.8 625.9 1270.6 631.4 1278.4 633.6C1283.2 635 1288.8 634.5 1292.7 631.3C1296.2 628.3 1297.7 623.6 1298.3 619.1C1299.8 607.8 1296.5 597 1288.3 589.5C1287.3 588.6 1286.3 587.7 1285.1 586.9C1278.2 581.9 1270 578.8 1263.8 572.8C1257.6 566.6 1252.9 558.6 1251.7 549.9C1251.3 547 1251.3 544 1250.6 541.1C1249.9 538.2 1248.4 535.4 1245.8 534C1244.6 533.4 1243.3 533.1 1242 533.1C1240.1 532.9 1238.2 533.5 1236.6 534.5Z" fill="url(#paint3_linear)"/>
                <path class="mobilehide" d="M1577.3 218.8C1574 223.1 1574.7 229.2 1579 232.5C1583.3 235.8 1589.4 235.1 1592.7 230.8C1596 226.5 1595.3 220.4 1591 217.1C1589.2 215.7 1587.1 215 1585 215C1582.1 215.1 1579.2 216.4 1577.3 218.8Z" fill="url(#paint4_linear)"/>
                <path class="mobilehide" d="M876.7 58.9C857.5 66.3 840.4 78.8 828.5 95.7C802.3 133.1 806.8 193.6 847.3 219.3C885.1 243.4 939.9 232 960.1 190.6C971.2 168 981.1 145.9 1008.9 141.9C1014.6 141.1 1020.4 141.1 1026 139.9C1056.7 133.3 1022 100.6 1012 91C989.3 69.2 959.6 54 928 51.4C924.9 51.1 921.8 51 918.7 51C904.4 51.1 890.1 53.8 876.7 58.9Z" fill="url(#paint5_linear)"/>
                <defs>
                <linearGradient id="paint0_linear" x1="2.89823" y1="914.109" x2="437.043" y2="742.305" gradientUnits="userSpaceOnUse">
                <stop stop-color="#EDF0F7" stop-opacity="0.75"/>
                <stop offset="1" stop-color="white"/>
                </linearGradient>
                <linearGradient id="paint1_linear" x1="1649.26" y1="718.38" x2="1649.26" y2="88.3501" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                <linearGradient id="paint2_linear" x1="113.602" y1="549.809" x2="113.602" y2="102" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                <linearGradient id="paint3_linear" x1="1263.22" y1="641.76" x2="1263.22" y2="546.337" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                <linearGradient id="paint4_linear" x1="1584.98" y1="236.005" x2="1584.98" y2="217.565" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                <linearGradient id="paint5_linear" x1="925.027" y1="245.045" x2="925.027" y2="74.6987" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FF974F"/>
                <stop offset="0.00128142" stop-color="#FF974F"/>
                <stop offset="1" stop-color="#FF5652"/>
                </linearGradient>
                </defs>
            </svg>

            <div class="caption">
                <h1 class="text h1">
                    Il travel per i concorsi a premi,
                    <br>
                    le promozioni e gli instant win
                </h1>
                <p class="small h3 not-first">
                    Al servizio delle tue promozioni e concorsi a premi abbiamo sviluppato una 
                    tecnologia e dei servizi che si caratterizzano per una User Experience che 
                    rispetta gli standard attesi, per una grande flessibilità e per un valore percepito fedele e puntuale.
                </p>
            </div>

            <ScrollTo selector="#scroll" />
        </div>

        <section class="boxed-text" data-aos="fade-up" id="scroll">
            <h2 class="title">
                Concorsi e promozioni in era post-Covid:
                <br>
                valore, valori ed esperienza utente (UX)
            </h2>
            <br>
            <p class="text">
                I big trend dei consumi post-Covid parlano di <b>qualità e valore</b>: valore reale e valore percepito.
                <br><br>
                Il consumatore è, oggi, sempre più competente e capace di analizzare il valore reale di qualsiasi prodotto e quindi anche del premio di un concorso.
                <b>Il consumatore cerca semplicità d’uso e flessibilità senza fronzoli anche nei concorsi a premio.</b>
            </p>
        </section>

        <section class="extraQuote" data-aos="fade-up">
            <b-container class="text-center">
                <div class="image">
                    <svg width="1214" height="349" viewBox="0 0 1214 349" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M151.705 10.7131C122.438 18.0432 93.8587 29.3201 69.6412 47.1377C45.4238 64.9554 26.0269 89.8775 18.337 118.521C8.35157 155.848 14.6642 194.641 3.53103 231.967C-5.76571 263.092 3.64581 296.584 27.6337 319.251C51.0477 341.354 85.1358 350.939 117.502 348.346C149.869 345.752 180.628 331.769 206.453 312.259C220.111 301.997 232.736 290.044 248.116 282.601C276.236 268.843 309.979 271.549 340.395 279.556C370.81 287.563 399.848 300.419 430.722 306.17C461.597 311.921 496.258 309.553 520.591 290.044C540.332 274.256 550.662 249.221 554.105 224.412C557.548 199.715 554.908 173.778 543.431 151.675C529.543 124.949 504.407 105.778 479.731 87.9604C456.891 71.496 433.821 55.3699 408.915 42.0631C357.152 14.3218 297.928 0 238.704 0C209.437 0 180.169 3.49586 151.705 10.7131Z" fill="url(#gradient-quote)"/>
                    <path d="M1188.04 272.054L203.998 256.614C192.526 256.614 182.469 249.28 179.169 238.472L130.768 96.1915C125.739 79.8251 138.232 63.3042 155.597 63.3042H1128.33C1139.8 63.3042 1149.86 70.7154 1153.16 81.4463L1212.87 239.166C1217.9 255.533 1205.49 272.054 1188.04 272.054Z" fill="#FDC500"/>
                    <path d="M1170.76 255.842H186.712C175.24 255.842 165.183 248.508 161.883 237.7L113.482 79.9793C108.454 63.6129 120.947 47.092 138.311 47.092H1122.36C1133.83 47.092 1143.89 54.5033 1147.19 65.2341L1195.59 222.954C1200.62 239.321 1188.2 255.842 1170.76 255.842Z" fill="#39414E"/>
                    <path d="M312.35 98.1216L293.885 142.435C302.921 148.456 307.4 158.569 307.4 169.455C307.4 189.604 292.628 203.654 272.513 203.654C254.049 203.654 237.706 191.534 237.706 169.455C237.706 158.955 241.791 150.155 247.134 142.049L277.856 98.1216H312.35ZM384.48 169.377C384.48 189.527 369.708 203.577 349.672 203.577C331.207 203.577 314.864 191.457 314.864 169.377C314.864 158.878 318.95 150.077 324.293 141.971L355.015 98.0444H389.43L370.965 142.357C380.001 148.456 384.48 158.492 384.48 169.377Z" fill="white"/>
                    <defs>
                    <linearGradient id="gradient-quote" x1="277.171" y1="374.32" x2="277.171" y2="45.7156" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FF974F"/>
                    <stop offset="0.00128142" stop-color="#FF974F"/>
                    <stop offset="1" stop-color="#FF5652"/>
                    </linearGradient>
                    </defs>
                    </svg>                        
                </div>
                <div class="text">
                    La forza delle nostre soluzioni sta nel valore concreto, tangibile e flessibile del premio che inserisci nelle tue promozioni.    
                </div>
            </b-container>
        </section>

        <b-container fluid data-aos="fade-up">
            <section class="b-cards">
                <b-row>
                    <b-col sm="12">
                        <div class="b-slider">
                            <div class="b-slides">
                                <Slick ref="slick" :options="bSlickOptions">
                                    <div class="b-slide">
                                        <div class="content">
                                            <div class="b-card">
                                                <div class="b-card--thumb" style="background-image:url('../../../../img/concorsi/card-1.png')"></div>
                                                <div class="b-card--text">
                                                    <h3 class="b-card--title">Integrazione</h3>
                                                    <p class="b-card--link">
                                                        Le soluzioni di travel booking Vivamod si integrano senza soluzione di continuità con le tue piattaforme di instant win, concorsi a premio e operazioni a premio certo.
                                                        <br><br>
                                                        Fanno vivere al cliente un’esperienza coinvolgente grazie alla possibilità, per esempio, di utilizzare il credito travel immediatamente dopo la vittoria di un instant win.
                                                        <br><br>
                                                        La dinamicità e la semplicità delle nostre soluzioni rappresentano gli standard attesi dal cliente contemporaneo che non accetta più perdite di tempo burocratiche che ritardano l’esperienza della vincita.
                                                        <!--
                                                        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                                            <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                                            <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                                                        </svg>                            
                                                        -->
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="b-slide">
                                        <div class="content">
                                            <div class="b-card">
                                                <div class="b-card--thumb" style="background-image:url('../../../../img/concorsi/card-2.png')"></div>
                                                <div class="b-card--text">
                                                    <h3 class="b-card--title">Tuning concettuale</h3>
                                                    <p class="b-card--link">
                                                        Creare una linea di continuità tematica tra la tua campagna e il suo viaggio premio è la nostra forza. Vivamod è nativo digitale, niente a che vedere con i vecchi pacchetti viaggio o i cofanetti.
                                                        <br><br>
                                                        Nelle mani di Vivamod il viaggio diventa una materia malleabile e a disposizione della tua creatività.
                                                        <br><br>
                                                        La tecnologia Vivamod ti permette di creare proposte di viaggio con mille diverse caratterizzazioni così da accordarsi con i tuoi messaggi di marketing e i valori della tua azienda.
                                                        <!--
                                                        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                                            <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                                            <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                                                        </svg>                            
                                                        -->
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="b-slide">
                                        <div class="content">
                                            <div class="b-card">
                                                <div class="b-card--thumb" style="background-image:url('../../../../img/concorsi/card-3.png')"></div>
                                                <div class="b-card--text">
                                                    <h3 class="b-card--title">UX di marca</h3>
                                                    <p class="b-card--link">
                                                        La User Experience Vivamod si fonde magicamente con la tua brand identity dando vita ad una customer journey fluida e aderente ai tuoi valori di marca.
                                                        <!--
                                                        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                                            <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                                            <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                                                        </svg>                            
                                                        -->
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="b-slide">
                                        <div class="content">
                                            <div class="b-card">
                                                <div class="b-card--thumb" style="background-image:url('../../../../img/concorsi/card-1.png')"></div>
                                                <div class="b-card--text">
                                                    <h5 class="b-card--title">Integrazione</h5>
                                                    <p class="b-card--link">
                                                        Le soluzioni di travel booking Vivamod si integrano senza soluzione di continuità con le tue piattaforme di instant win, concorsi a premio e operazioni a premio certo.
                                                        <br><br>
                                                        Fanno vivere al cliente un’esperienza coinvolgente grazie alla possibilità, per esempio, di utilizzare il credito travel immediatamente dopo la vittoria di un instant win.
                                                        <br><br>
                                                        La dinamicità e la semplicità delle nostre soluzioni rappresentano gli standard attesi dal cliente contemporaneo che non accetta più perdite di tempo burocratiche che ritardano l’esperienza della vincita.
                                                        <!--
                                                        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                                            <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                                            <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                                                        </svg>                            
                                                        -->
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="b-slide">
                                        <div class="content">
                                            <div class="b-card">
                                                <div class="b-card--thumb" style="background-image:url('../../../../img/concorsi/card-2.png')"></div>
                                                <div class="b-card--text">
                                                    <h5 class="b-card--title">Tuning concettuale</h5>
                                                    <p class="b-card--link">
                                                        Creare una linea di continuità tematica tra la tua campagna e il suo viaggio premio è la nostra forza. Vivamod è nativo digitale, niente a che vedere con i vecchi pacchetti viaggio o i cofanetti.
                                                        <br><br>
                                                        Nelle mani di Vivamod il viaggio diventa una materia malleabile e a disposizione della tua creatività.
                                                        <br><br>
                                                        La tecnologia Vivamod ti permette di creare proposte di viaggio con mille diverse caratterizzazioni così da accordarsi con i tuoi messaggi di marketing e i valori della tua azienda.
                                                        <!--
                                                        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                                            <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                                            <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                                                        </svg>                            
                                                        -->
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="b-slide">
                                        <div class="content">
                                            <div class="b-card">
                                                <div class="b-card--thumb" style="background-image:url('../../../../img/concorsi/card-3.png')"></div>
                                                <div class="b-card--text">
                                                    <h5 class="b-card--title">UX di marca</h5>
                                                    <p class="b-card--link">
                                                        La User Experience Vivamod si fonde magicamente con la tua brand identity dando vita ad una customer journey fluida e aderente ai tuoi valori di marca.
                                                        <!--
                                                        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path opacity="0.3" d="M53.4704 27.2272C53.4704 41.7774 41.7057 53.5749 27.1959 53.5749C12.6861 53.5749 0.921387 41.7774 0.921387 27.2272C0.921387 12.6769 12.6861 0.879395 27.1959 0.879395C41.7057 0.879395 53.4704 12.6769 53.4704 27.2272Z" fill="#283D4D"/>
                                                            <path d="M47.1958 27.2271C47.1958 38.3168 38.2546 47.2829 27.1958 47.2829C16.137 47.2829 7.1958 38.3168 7.1958 27.2271C7.1958 16.1375 16.137 7.17139 27.1958 7.17139C38.2546 7.17139 47.1958 16.1375 47.1958 27.2271Z" fill="#157FFB"/>
                                                            <path d="M23.7452 35.8786C23.2746 35.8786 22.8825 35.7213 22.4903 35.4067C21.7845 34.6989 21.7845 33.5977 22.4903 32.9685L28.2158 27.2271L22.4903 21.4856C21.7845 20.7778 21.7845 19.6767 22.4903 19.0475C23.1962 18.3396 24.2943 18.3396 24.9217 19.0475L31.9021 26.0474C32.608 26.7552 32.608 27.8563 31.9021 28.4855L24.9217 35.4854C24.608 35.7213 24.1374 35.8786 23.7452 35.8786Z" fill="white"/>
                                                        </svg>                            
                                                        -->
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Slick>
                            </div>

                            <div class="b-left" id="b-left">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M80 40.0001C80 62.0097 62.0097 80.0001 40.0001 80.0001C17.9905 80.0001 0 62.0097 0 40.0001C0 17.9905 17.9905 0 40.0001 0C62.0097 0 80 17.9905 80 40.0001Z" fill="#CCCCCC"/>
                                    <g filter="url(#filter0_dleft)">
                                    <path d="M70.4305 40.0001C70.4305 56.8422 56.8422 70.4308 40.0001 70.4308C23.1579 70.4308 9.56934 56.8422 9.56934 40.0001C9.56934 23.1579 23.1579 9.5694 40.0001 9.5694C56.8422 9.5694 70.4305 23.3493 70.4305 40.0001Z" fill="white"/>
                                    </g>
                                    <path d="M45.1672 26.8429C45.9328 26.8429 46.507 27.0343 47.0811 27.6084C48.0381 28.5654 48.0381 30.2879 47.0811 31.4362L38.4687 40.0487L47.0811 48.6611C48.0381 49.6181 48.0381 51.3405 47.0811 52.4889C46.1242 53.4458 44.4017 53.4458 43.2534 52.4889L32.727 41.9625C31.7701 41.0056 31.7701 39.2831 32.727 38.1348L43.2534 27.6084C43.8275 27.0343 44.4017 26.8429 45.1672 26.8429Z" fill="#39414E"/>
                                    <defs>
                                    <filter id="filter0_dleft" x="7.56934" y="7.5694" width="66.8612" height="66.8614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dx="1" dy="1"/>
                                    <feGaussianBlur stdDeviation="1.5"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                            </div>
                            <div class="b-right" id="b-right">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.3" d="M80 40.0001C80 62.0097 62.0097 80.0001 40.0001 80.0001C17.9905 80.0001 0 62.0097 0 40.0001C0 17.9905 17.9905 0 40.0001 0C62.0097 0 80 17.9905 80 40.0001Z" fill="#CCCCCC"/>
                                    <g filter="url(#filter0_dright)">
                                    <path d="M70.4305 40.0001C70.4305 56.8422 56.8422 70.4308 40.0001 70.4308C23.1579 70.4308 9.56934 56.8422 9.56934 40.0001C9.56934 23.1579 23.1579 9.5694 40.0001 9.5694C56.8422 9.5694 70.4305 23.3493 70.4305 40.0001Z" fill="white"/>
                                    </g>
                                    <path d="M34.6413 53.2066C33.8758 53.2066 33.3016 53.0152 32.7275 52.441C31.7705 51.4841 31.7705 49.7616 32.7275 48.6133L41.3399 40.0008L32.7275 31.3884C31.7705 30.4314 31.7705 28.7089 32.7275 27.5606C33.6844 26.6037 35.4069 26.6037 36.5552 27.5606L47.0816 38.0869C48.0385 39.0439 48.0385 40.7664 47.0816 41.9147L36.5552 52.441C35.9811 53.0152 35.4069 53.2066 34.6413 53.2066Z" fill="#39414E"/>
                                    <defs>
                                    <filter id="filter0_dright" x="7.56934" y="7.5694" width="66.8612" height="66.8614" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dx="1" dy="1"/>
                                    <feGaussianBlur stdDeviation="1.5"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                                    </filter>
                                    </defs>
                                </svg>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </section>
        </b-container>   

        <section class="section--card-with-background" data-aos="fade-up">
            <img class="floatingImg" src="img/concorsi/card-bg.png" />
            <div class="content">
                <div class="card">
                    <div class="icon"><img src="img/concorsi/icon-1.svg"/></div>
                    <h2 class="title">Instant win</h2>
                    <p class="text">
                        <b>Instant sul serio</b> - l’utente può immediatamente utilizzare il credito travel che si è aggiudicato.
                        <br><br>
                        <b>Flessibile</b> - il credito ha comunque una validità nel tempo e può essere speso con totale flessibilità frazionandolo in diverse prenotazioni ed integrandolo con carta di credito.
                        <br><br>
                        <b>Grandi operazioni</b> - il credito vinto può essere integrato con la carta di credito e permette quindi anche grandi operazioni con un elevatissimo numero di vincitori e un valore della vincita limitato.
                    </p>
                </div>
                <div class="card">
                    <div class="icon"><img src="img/concorsi/icon-2.svg"/></div>
                    <h2 class="title">Concorsi a premio certo</h2>
                    <p class="text">
                        I <b>nostri crediti travel di piccolo o piccolissimo taglio</b> si adattano perfettamente a grandi operazioni a premio certo.
                        <br><br>
                        <b>Credito immediatamente spendibile</b> su un sito brandizzato e con proposte di viaggio in linea con la tua campagna e i tuoi valori di marca.
                    </p>
                </div>
                <div class="card">
                    <div class="icon"><img src="img/concorsi/icon-3.svg"/></div>
                    <h2 class="title">Concorsi a premio</h2>
                    <p class="text">
                        Se il premio di un concorso, magari l’estrazione finale, prevede premi di valore importante Vivamod ha due risposte.
                        <br><br>
                        <b class="h5">Un credito di valore significativo</b>
                        <ul>
                            <li>frazionabile</li>
                            <li>integrabile</li>
                            <li>spendibile entro 16 mesi</li>
                        </ul>
                        <br>
                        <b class="h5">Un cofanetto viaggio digitale</b>
                        <br>
                        La logica è la stessa del cofanetto regalo tradizionale con la differenza che i nostri cofanetti sono nativi digitali e quindi dinamici con booking in real time e privi di tutti i limiti di disponibilità in fase di prenotazione dei cofanetti tradizionali.
                        <br><br>
                        <b>In più, anche in questo caso, avrai l’integrazione con le tue piattaforme IT e la possibilità di brandizzazione e tematizzazione dei cofanetti.</b>
                    </p>
                </div>
            </div>
        </section>

        <section class="section--card-cofanetti" data-aos="fade-up">
            <b-container fluid>
                <h2 class="title text-center h2">Card e cofanetti</h2>
                <div class="content">
                    <img class="bg" src="img/cards-bg.svg" />
                    <img class="cards" src="img/cards.png" />
                </div>
                <div class="link"><a href="#" class="btn">Scopri di più</a></div>
                <div class="drop">
                    <img class="bg" src="img/card-cofanetti-bg.svg" />
                    <div class="text">
                        il credito travel Vivamod può essere inserito nella tua campagna anche sotto forma di tradizionali card in cartoncino o PVC o cofanetti di cartone brandizzabili a tuo piacimento
                    </div>
                </div>
            </b-container>
        </section>

        <section class="section--data-insight" data-aos="fade-up">
            <b-container fluid>
                <b-row>
                    <b-col xs="12" sm="6">
                        <div class="content">
                            <h2 class="title">PROFILAZIONE CLIENTI E DATA INSIGHT</h2>
                            <div class="text">
                                <br>
                                Se la tua base clienti è profilata sarà possibile differenziare la nostra proposta di viaggi premio per rispondere al meglio a tutti i singoli profili demografici della clientela.
                                <br><br>
                                In base alle privacy policy concordate e definite possiamo mettere a tua disposizione un prezioso flusso di dati sui comportamenti e le preferenze degli utenti della promozione e della tua campagna
                            </div>
                            <img class="bg" src="svg/bg-insight.svg" />
                        </div>
                    </b-col>
                    <b-col xs="12" sm="6">
                        <div class="image" style="background-image:url('../../../../img/concorsi/data-insight.jpg')"></div>
                    </b-col>
                </b-row>
            </b-container>
        </section>

        <b-container data-aos="fade-up">
            <section>
                <FormContatti
                    formTitle="Contattaci"
                    formSubtitle="Per approfondire meglio le nostre soluzioni e quello che possiamo fare per il tuo marketing"
                />
            </section>
        </b-container>

        <section class="section--prefooter" data-aos="fade-up">
            <b-container fluid>
                <b-row>
                    <b-col sm="6">
                        <div class="content">
                            <h4 class="subtitle">Concorsi a premio, la normativa e le tendenze recenti</h4>
                            <div class="text">
                                <p>
                                    Le manifestazioni a premio, realizzate sotto forma di concorsi o di operazioni a premio, sono iniziative di  produttori e rivenditori per stimolare gli acquisti, incrementare le vendite, promuovere l'immagine aziendale e gratificare i consumatori.
                                </p>
                                <p>
                                    Le manifestazioni a premio si suddividono in due tipi di iniziative:
                                    <br>
                                    -    i concorsi a premio, in cui l'attribuzione dei premi dipende dalla sorte, da qualsiasi congegno, dall'abilità o dalla capacità dei concorrenti;
                                    <br>
                                    -    le operazione a premio, incui l'attribuzione dei premi è condizionata ad una determinata azione del cliente, dalla più semplice come ad esempio la registrazione al sito o il download dell'app, fino a quelle più avanzate come l'acquisto di prodotti e/o servizi.
                                </p>
                                <p>
                                    Prima della diffusione di Internet le più usate come attività di marketing dalle imprese produttrici di beni tradizionali erano le operazioni a premi, che miravano a fidelizzare i clienti e ad aumentare il fatturato. Con Internet gli obiettivi sono cambiati: si punta all’acquisizione di lead, al coinvolgimento dei partecipanti nei valori del brand e alla trasmissione a questi di determinate caratteristiche di un prodotto promozionato. I concorsi a premi diventano, quindi, una delle attività di marketing più utilizzate dalle imprese, in quanto sono capaci di soddisfare tutti gli obiettivi descritti e necessitano di un budget decisamente inferiore rispetto a quello richiesto per le operazioni a premi.
                                </p>
                                <p>
                                    Esistono diverse tipologie di concorsi a premi online, ognuna delle quali è migliore delle altre per conseguire un diverso obiettivo: la lead generation, il brand o il product awareness. Le tipologie di concorsi più diffuse sono gli instant win, i concorsi con estrazione finale e i concorsi meritocratici.
                                </p>
                                <p>
                                    Scegliere i premi di un concorso è una delle fasi più importanti per poter raggiungere gli obiettivi prefissati dall’impresa, bisogna dunque definire quali sono i target di consumatori che si vuole raggiungere con il concorso e scegliere un premio che attiri questi. I premi possono consistere in beni che si vogliono raggiungere con il concorso e scegliere un premio adeguato, servizi, sconti di prezzo e documenti di legittimazione di cui all'articolo 2002 del codice civile, giocate del lotto o biglietti delle lotterie nazionali. Il premio è solitamente coerente con il brand che lancia il concorso e il valore del premio è spesso bilanciato alla difficoltà del concorso e allo sforzo che deve fare l’utente per parteciparvi.
                                </p>
                            </div>
                        </div>
                    </b-col>
                    <b-col sm="6">
                        <div class="image">
                            <div class="image" style="background-image:url('../../../../img/concorsi/prefooter.jpg')"></div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </section>


    </div>
</template>

<script>
    import Slick from 'vue-slick'
    import FormContatti from '@/components/blocks/form-contatti'
    import ScrollTo from '@/components/atoms/scroll-to'
    //import SvgChevronLeft from '@/components/svg/chevron-left'
   // import SvgChevronRight from '@/components/svg/chevron-right'
    
    export default {
        name: 'concorsi',
        metaInfo: {
          title: 'Concorsi a premio - Il Travel per i tuoi concorsi',
          meta: [
            { vmid: 'metaDescription', name: 'Description', content: 'Concorsi a premi con soluzioni di travel booking per le tue promozioni e gli instant win che si caratterizzano per una User Experience personalizzata.' },
            { vmid: 'dcDescription', name: 'DC.description', lang: 'it', content: 'Concorsi a premi con soluzioni di travel booking per le tue promozioni e gli instant win che si caratterizzano per una User Experience personalizzata.' },
            { vmid: 'ogTitle', property: 'og:title', content: 'Concorsi a premio - Il Travel per i tuoi concorsi | Vivamod' },
            { vmid: 'ogDescription', name: 'og:description', content: 'Concorsi a premi con soluzioni di travel booking per le tue promozioni e gli instant win che si caratterizzano per una User Experience personalizzata.' },
          ],
        },
        components: {
            Slick,
            FormContatti,
            ScrollTo,
            //SvgChevronLeft,
            //SvgChevronRight,
        },
        data()
        {
            return {
                bSlickOptions: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots:false,
                        //fade:true,
                        //arrows:false,
                        //autoplay:true,
                        speed: 500,
                        //autoplaySpeed: 7500,
                        prevArrow: '#b-left',
                        nextArrow: '#b-right',
                        responsive: [
                            {
                            breakpoint: 1140,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                            breakpoint: 600,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                }
                            }
                        ]
                },
            }
        },
        methods: {
        },
        mounted()
        {
        }
    }
</script>

<style lang="scss">
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/mixins";
    @import './../../scss/_custom.scss';
    #concorsi
    {
        .hero-background
        {
            background: $dark-blue;
            margin-top: -2px;
            min-height: 300px;
            width:100%;
            position:relative;
            .background
            {
                display:block;
                height:auto;
                width:100%;
                position:absolute;
                bottom:0;
                background:$white;
            }
            .overlay
            {
                display:block;
                height:auto;
                width:100%;
                position:relative;
                z-index: 1;
                padding-top:50px;
                .mobilehide
                {
                    display:none;
                    @include media-breakpoint-up(sm)
                    {
                        display: inline;
                    }
                }
                @include media-breakpoint-up(sm)
                {
                    padding-top:100px;
                }
                @include media-breakpoint-up(sm)
                {
                    padding-top:70px;
                }
                @include media-breakpoint-up(sm)
                {
                    padding-top:90px;
                }
            }
            .caption
            {
                color:$white;
                position:absolute;
                top:25%;
                left:$grid-gutter-width/4;
                max-width: 240px;
                z-index: 10;
                .title
                {
                    color: $white;
                    font-size: 18px;
                }
                *
                {
                    color:$white;
                }
                .text p
                {
                    color:$white;
                    font-weight: 400;
                }
                @include media-breakpoint-up(sm)
                {
                    left:$grid-gutter-width;
                    top:35%;
                    max-width: 340px;
                    .title
                    {
                        font-size: 16px;
                    }
                    .text
                    {
                    }
                }
                @include media-breakpoint-up(md)
                {
                    left:$grid-gutter-width;
                    top:35%;
                    max-width: 450px;
                    .title
                    {
                        font-size: 22px;
                    }
                    .text
                    {
                    }
                }
                @include media-breakpoint-up(xl)
                {
                    left:10%;
                    top:30%;
                    max-width: 50%;
                    .title
                    {
                        font-size: 40px;
                    }
                    .text
                    {
                    }
                }
                @include media-breakpoint-up(xxl)
                {
                    .title
                    {
                        font-size: 50px;
                    }
                    .text
                    {
                    }
                }
            }

            @include media-breakpoint-up(lg)
            {
                .background
                {
                    position:relative;
                    margin-top:-1vh;
                }
                .overlay
                {
                    position:absolute;
                    top:0;
                    padding-top:100px;
                }
                .caption
                {
                    top:45%;
                }
            }

            @include media-breakpoint-up(xl)
            {
                .background
                {
                    position:relative;
                    margin-top:-3vh;
                }
                .overlay
                {
                    position:absolute;
                    top:0;
                    padding-top:140px;
                }
                .caption
                {
                    top:40%;
                }
            }
        
            @include media-breakpoint-up(xxl)
            {
                .background
                {
                    position:relative;
                    margin-top:-12vh;
                }
                .overlay
                {
                    position:absolute;
                    top:0;
                    padding-top:220px;
                }
                .caption
                {
                    top:45%;
                }
            }
        }

        .extraQuote
        {
            margin-top:0;
            padding-top:0;
            .container
            {
                position:relative;
            }
            .text
            {
                /*
                @include media-breakpoint-down(xs)
                {
                    font-size: 9px;
                    line-height: 1.2;
                    width: 50%;
                    top: 40%;
                }
                @include media-breakpoint-up(xl)
                {
                    font-size: 26px;
                    padding-left:20px;
                }
                */
            }
        }

        .b-cards
        {
            display:block;
            max-width:1600px;
            .slick-track
            {
                display:flex;
            }
            .slick-slide
            {
                height:inherit;
                min-height:100%;
            }
            .slick-slide > div
            {
                height:inherit;
                min-height:100%;
                display: flex;
            }
            .b-slide
            {
                height:inherit;
                flex:1;
                margin:0;
            }
            .content,
            .b-card
            {
                height:100%;
                cursor:pointer;
            }
            .b-card
            {
                display:flex;
                flex-direction: column;
                &--text
                {
                    flex:1;
                }
            }
            .b-card--text
            {
                margin-top:-20px;
            }
            @include media-breakpoint-down(md)
            {
                .b-card--link
                {
                    //font-size: 12px;
                }
                .b-card--text
                {
                    margin-top:-60px;
                }
            }
        }



        .section--card-with-background
        {
            @include media-breakpoint-up(sm)
            {
                .card:nth-child(1),
                .card:nth-child(2)
                {
                    width:calc(50% - #{$grid-gutter-width});
                }

                .card:nth-child(3)
                {

                }

                .card:nth-child(2)
                {
                    transform:translateY(15%);
                }
            }
            @include media-breakpoint-up(xl)
            {
                .card
                {
                    margin:$grid-gutter-width;
                }
                .card:nth-child(1),
                .card:nth-child(2)
                {
                    width:calc(50% - #{$grid-gutter-width*2});
                }
                .card:nth-child(2)
                {
                    transform:translateY(40%);
                }
            }
        }


        .small
        {
            //color:$light-gray;
            font-weight: 400;
        }

    }
</style>